import Api from '../services/Api'

export const createVendor = async (name) => {
  const response = await Api.post('/vendors', {
    name,
  })

  return response.data
}
